export default "__VITE_ASSET__Co7F_kXp__"